import React, { useRef } from "react";
import BlueTick from "../../../assets/svg/icons/common/blue-tick";
import GrayCross from "../../../assets/svg/icons/common/gray-cross";
import styles from "./styles.module.scss";
import useDomainStore from "../../../stores/domain";

const SwitchLabel = ({ label, size, onClick }) => {
  return (
    <span className={`${styles.switchText} ${styles[size]}`} onClick={onClick}>
      {label}
    </span>
  );
};

const Switch = ({
  id,
  name,
  label,
  labelSize = "small",
  labelPosition = "right",
  value,
  dimWhenDisabled = false,
  ...props
}) => {
  const { isKurvDomain } = useDomainStore();
  const inputRef = useRef(null);
  const isDimmed = props?.disabled && dimWhenDisabled;

  const handleLabelClick = () => {
    if (props?.disabled) return;

    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <div
      className={`${styles.switchContainer} ${props?.disabled && styles.disabled} ${isDimmed && styles.dimmed} ${isKurvDomain ? styles.kurv_theme : ""}`}
    >
      <label htmlFor={id}></label>
      {label && labelPosition === "left" && (
        <SwitchLabel
          label={label}
          onClick={handleLabelClick}
          size={labelSize}
        />
      )}
      <div className={styles.switch}>
        <input
          id={id}
          ref={inputRef}
          type="checkbox"
          name={name}
          value={value}
          {...props}
        />
        <div className={styles.circle}>
          <span className={styles.checkedState}>
            <BlueTick fill={isKurvDomain ? "#22A276" : "#4C70EF"} />
          </span>
          <span className={styles.uncheckedState}>
            <GrayCross />
          </span>
        </div>
      </div>
      {label && labelPosition === "right" && (
        <SwitchLabel
          label={label}
          size={labelSize}
          onClick={handleLabelClick}
        />
      )}
    </div>
  );
};

export default Switch;
